import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface FiltersKeyType {
  booleanOptions: {
    any: LocalesKey;
    false: LocalesKey;
    true: LocalesKey;
  };
  dateOptions: {
    exactDay: LocalesKey;
    equals: LocalesKey;
    notEquals: LocalesKey;
    before: LocalesKey;
    after: LocalesKey;
    between: LocalesKey;
    blank: LocalesKey;
    notBlank: LocalesKey;
    numberOfDaysAgo: LocalesKey;
    numberOfDaysFromNow: LocalesKey;
    oneMonthAgo: LocalesKey;
    oneMonthFromNow: LocalesKey;
    oneWeekAgo: LocalesKey;
    oneWeekFromNow: LocalesKey;
    theNextMonth: LocalesKey;
    theNextNumberOfDays: LocalesKey;
    theNextWeek: LocalesKey;
    theNextYear: LocalesKey;
    thePastMonth: LocalesKey;
    thePastNumberOfDays: LocalesKey;
    thePastWeek: LocalesKey;
    thePastYear: LocalesKey;
    thisCalendarMonth: LocalesKey;
    thisCalendarWeek: LocalesKey;
    thisCalendarYear: LocalesKey;
    today: LocalesKey;
    tomorrow: LocalesKey;
    yesterday: LocalesKey;
  };
  datePresets: {
    today: LocalesKey;
    yesterday: LocalesKey;
    last7Days: LocalesKey;
    last30Days: LocalesKey;
    last3Months: LocalesKey;
    last12Months: LocalesKey;
    moreThan7DaysAgo: LocalesKey;
    moreThan30DaysAgo: LocalesKey;
    moreThan3MonthsAgo: LocalesKey;
    moreThan12MonthsAgo: LocalesKey;
    thisWeek: LocalesKey;
    thisMonth: LocalesKey;
    thisYear: LocalesKey;
  };
  numberOptions: {
    equals: LocalesKey;
    notEquals: LocalesKey;
    between: LocalesKey;
    blank: LocalesKey;
    notBlank: LocalesKey;
    greaterThan: LocalesKey;
    lessThan: LocalesKey;
    greaterThanOrEqual: LocalesKey;
    lessThanOrEqual: LocalesKey;
  };
  textOptions: {
    contains: LocalesKey;
    notContains: LocalesKey;
    equals: LocalesKey;
    notEquals: LocalesKey;
    startsWith: LocalesKey;
    endsWith: LocalesKey;
    blank: LocalesKey;
    notBlank: LocalesKey;
  };
  enterDays: LocalesKey;
  enterFilterName: LocalesKey;
  saveCurrentFilters: LocalesKey;
  modes: {
    contains: LocalesKey;
    containsAllOf: LocalesKey;
    containsAnyOf: LocalesKey;
    containsNoneOf: LocalesKey;
    containsOnly: LocalesKey;
    doesNotContainAnyOf: LocalesKey;
    endsWith: LocalesKey;
    is: LocalesKey;
    isAfter: LocalesKey;
    isAnyOf: LocalesKey;
    isBefore: LocalesKey;
    isEmpty: LocalesKey;
    isNoneOf: LocalesKey;
    isNot: LocalesKey;
    isNotEmpty: LocalesKey;
    isOnOrAfter: LocalesKey;
    isOnOrBefore: LocalesKey;
    isWithin: LocalesKey;
    startsWith: LocalesKey;
    greaterThanEqual: LocalesKey;
    lessThanEqual: LocalesKey;
  };
  users: {
    containsAnyOf: LocalesKey;
    doesNotContainAnyOf: LocalesKey;
    isEmpty: LocalesKey;
    isNotEmpty: LocalesKey;
  };
}

export const filtersKeys = keyPathMirror<FiltersKeyType, string>(
  {
    booleanOptions: {
      any: null,
      false: null,
      true: null
    },
    dateOptions: {
      exactDay: null,
      equals: null,
      notEquals: null,
      before: null,
      after: null,
      between: null,
      blank: null,
      notBlank: null,
      numberOfDaysAgo: null,
      numberOfDaysFromNow: null,
      oneMonthAgo: null,
      oneMonthFromNow: null,
      oneWeekAgo: null,
      oneWeekFromNow: null,
      theNextMonth: null,
      theNextNumberOfDays: null,
      theNextWeek: null,
      theNextYear: null,
      thePastMonth: null,
      thePastNumberOfDays: null,
      thePastWeek: null,
      thePastYear: null,
      thisCalendarMonth: null,
      thisCalendarWeek: null,
      thisCalendarYear: null,
      today: null,
      tomorrow: null,
      yesterday: null
    },
    datePresets: {
      today: null,
      yesterday: null,
      last7Days: null,
      last30Days: null,
      last3Months: null,
      last12Months: null,
      moreThan7DaysAgo: null,
      moreThan30DaysAgo: null,
      moreThan3MonthsAgo: null,
      moreThan12MonthsAgo: null,
      thisWeek: null,
      thisMonth: null,
      thisYear: null
    },
    numberOptions: {
      equals: null,
      notEquals: null,
      between: null,
      blank: null,
      notBlank: null,
      greaterThan: null,
      lessThan: null,
      greaterThanOrEqual: null,
      lessThanOrEqual: null
    },
    textOptions: {
      contains: null,
      notContains: null,
      equals: null,
      notEquals: null,
      startsWith: null,
      endsWith: null,
      blank: null,
      notBlank: null
    },
    enterDays: null,
    enterFilterName: null,
    saveCurrentFilters: null,
    modes: {
      contains: null,
      containsAllOf: null,
      containsAnyOf: null,
      containsNoneOf: null,
      containsOnly: null,
      doesNotContainAnyOf: null,
      endsWith: null,
      is: null,
      isAfter: null,
      isAnyOf: null,
      isBefore: null,
      isEmpty: null,
      isNoneOf: null,
      isNot: null,
      isNotEmpty: null,
      isOnOrAfter: null,
      isOnOrBefore: null,
      isWithin: null,
      startsWith: null,
      greaterThanEqual: null,
      lessThanEqual: null
    },
    users: {
      containsAnyOf: null,
      doesNotContainAnyOf: null,
      isEmpty: null,
      isNotEmpty: null
    }
  },
  'models.filters.'
);
